import { render, staticRenderFns } from "./goodsSpecification.vue?vue&type=template&id=408fa02d"
import script from "./goodsSpecification.vue?vue&type=script&lang=js"
export * from "./goodsSpecification.vue?vue&type=script&lang=js"
import style0 from "./goodsSpecification.vue?vue&type=style&index=0&id=408fa02d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports